<template>
  <main>
    <div class="clearfix mt3 mb2">
      <p class="h5 gibson darkblue line-height-golden regular">Her kan du tilføje nye sider og redigere indholdet på din hjemmeside.</p>
    </div>
    <template>
      <div v-if="showMobile">
        <b-tabs pills vertical>
          <b-tab>
            <template #title>
              <img src='static/svg/sitemap.svg' width='28' height='28'><p class='inline-block h6 p1 gibson'>Sider</p>
            </template>
            <websitecontents :filteredPosts="filteredPosts" @Reload="Reload"></websitecontents>
          </b-tab>
          <b-tab>
            <template #title>
              <img src='static/svg/list.svg' width='28b-tab' height='28'><p class='inline-block h6 p1 gibson'>Sidernes rækkefølge</p>
            </template>
            <websitesort :filteredPosts="filteredPosts" :titles="titles" :filteredSorts="filteredSorts" @Reload="Reload" ></websitesort>
          </b-tab>
          <b-tab>
            <template #title>
              <img src='static/svg/layout.svg' width='28' height='28'><p class='inline-block h6 p1 gibson'>Temaer</p>
            </template>
            <div class="clearfix relative highlights mb4"  v-for="template in templates" :key="template.id">
              <div class="col-12 px0 relative">
                <div class="relative">
                  <img class="fit" :src="template.img" :alt="template.id">
                </div>
                <div class="absolute right-0 bottom-0 left-0" style="bottom:-20px;">
                  <div class="col-6 mx-auto highlights flex flex-column p1 white-background">
                    <span class="block mb2 flex justify-between items-center">
                      <span class="h6 darkblue gibson line-height-1 m0 p0 capitalize" style="font-size:90%">
                        {{template.id}}
                      </span>
                      <template>
                        <span v-if="template.id === 'theme1'" class="darkblue gibson block flex justify-start items-center">
                          <span class="green"><i class="el-icon-success"></i></span>
                          <span class="h6 regular m0 p0" style="font-size:90%">Menu</span>
                        </span>
                        <span class="lightgrey gibson block flex justify-start items-center" v-else>
                          <span><i class="el-icon-remove"></i></span>
                          <span class="h6 regular gibson m0 p0 line-height-1" style="font-size:90%">Menu</span>
                        </span>
                      </template>
                    </span>
                    <button type="button" v-if="template.id !== vtemplate" @click="Updatetemplate(template.id)" class="action-button gibson line-height-1 flex justify-center items-center h6 regular py1 px2 flex-none mx-auto">
                      <span style="font-size:90%">Vælg</span>
                    </button>
                    <div class="center mx-auto py1 px2 border green-border mb1" v-if="template.id === vtemplate">
                      <p class="h6 gibson green line-height-1 m0 p0" style="font-size:90%">Valgte</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="py4"></div>
          </b-tab>
          <b-tab>
            <template #title>
              <img src='static/svg/settings.svg' width='28' height='28'><p class='inline-block h6 p1 gibson'>Indstillinger</p>
            </template>
            <div class="px1">
              <form @submit="onUpdateSettings" @reset="onResetSettings">
                <div class="py2"></div>
                <div class="clearfix mb3">
                  <b-form-group id="settings1" class="gibson h5 regular mb1 darkblue">
                    <label label-for="siteTitle" class="h5 semi-bold darkblue gibson mb1">Navn på hjemmeside</label>
                    <b-form-input id="siteTitle" v-model="siteSettings.Title" class="border-none not-rounded gibson p2 h5 muted-background darkblue"></b-form-input>
                    <span class="h5 mediumgrey regular line-height-3 gibson">
                      Her skriver du navnet på din hjemmeside fx hansensvvs.dk
                    </span>
                  </b-form-group>
                </div>
                <div class="clearfix mb3">
                  <b-form-group id="settings3">
                    <label label-for="siteKeywords" class="h5 semi-bold darkblue gibson mb1">Søgeord</label>
                    <b-form-input id="siteKeywords" v-model="siteSettings.Keywords" class="border-none not-rounded gibson p2 h5 muted-background darkblue"></b-form-input>
                    <span class="h5 mediumgrey regular line-height-3 gibson">
                      Her skriver du de søgeord, som du ønsker at din hjemmeside skal blive fundet på, det kan fx være dit firmanavn, produktnavne eller lignende
                    </span>
                  </b-form-group>
                </div>
                <div class="clearfix mb3">
                  <b-form-group id="settings1">
                    <label label-for="Facebook" class="h5 semi-bold darkblue gibson mb1">
                      Link til virksomhedens Facebookside
                    </label>
                    <b-form-input id="Facebook" v-model="siteSettings.facebook" class="border-none not-rounded gibson p2 h5 muted-background darkblue"></b-form-input>
                    <span class="h5 mediumgrey regular line-height-3 gibson">
                      Hvis du ønsker at tilføje et link til din virksomheds profil på de Facebook/Instagram kan du gøre det her
                    </span>
                  </b-form-group>
                </div>
                <div class="clearfix mb3">
                  <b-form-group id="settings3" label="" >
                    <label label-for="Instagram" class="h5 semi-bold darkblue gibson mb1">
                      Link til virksomhedens Instagramside
                    </label>
                    <b-form-input id="Twitter" v-model="siteSettings.twitter" class="border-none not-rounded gibson p2 h5 muted-background darkblue"></b-form-input>
                    <span class="h5 mediumgrey regular line-height-3 gibson">
                      Hvis du ønsker at tilføje et link til din virksomheds profil på de Facebook/Instagram kan du gøre det her
                    </span>
                  </b-form-group>
                </div>
                <div class="clearfix mb3">
                  <b-form-group id="settings2">
                    <label label-for="siteDescription" class="h5 semi-bold darkblue gibson mb1">Beskrivelse</label>
                    <b-form-textarea id="siteDescription" v-model="siteSettings.Description" :rows="8" :max-rows="6" class="border-none not-rounded gibson p2 h5 muted-background darkblue"></b-form-textarea>
                    <span class="h5 mediumgrey regular line-height-3 gibson">
                      Som standard vil beskrivelsen på din hjemmeside, være din profiltekst fra Håndværker.dk, ønsker du at lave en anden beskrivelse, kan du gøre det her
                    </span>
                  </b-form-group>
                </div>
                <div class="clearfix mb3">
                  <template>
                    <div v-if="!image">
                      <div class="font-weight-bold p-1">Logo</div>
                      <input type="file" @change="onFileChange">
                    </div>
                    <div v-else>
                      <p class="h5 semi-bold gibson mb2 darkblue">
                        Logo
                      </p>
                      <div class="flex justify-start items-start">
                        <div style="width:100px;height:100px;">
                          <img class="fit block" :src="image" />
                        </div>
                        <button class="not-rounded p1 delete-button" @click="removeImage">
                          <span>
                            <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-3 -2 24 24" width="24" height="24" preserveAspectRatio="xMinYMin" class="jam jam-trash"><path d='M6 2V1a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v1h4a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2h-.133l-.68 10.2a3 3 0 0 1-2.993 2.8H5.826a3 3 0 0 1-2.993-2.796L2.137 7H2a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h4zm10 2H2v1h14V4zM4.141 7l.687 10.068a1 1 0 0 0 .998.932h6.368a1 1 0 0 0 .998-.934L13.862 7h-9.72zM7 8a1 1 0 0 1 1 1v7a1 1 0 0 1-2 0V9a1 1 0 0 1 1-1zm4 0a1 1 0 0 1 1 1v7a1 1 0 0 1-2 0V9a1 1 0 0 1 1-1z'/></svg>
                          </span>
                        </button>
                      </div>
                    </div>
                  </template>
                </div>
                <div class="clearfix mb3">
                  <button type="submit" class="not-rounded action-button gibson h4 regular col-12 flex justify-center items-center p2">
                    <span>
                      <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-1.5 -2.5 24 24" width="24" height="24" preserveAspectRatio="xMinYMin" class="jam jam-refresh"><path d='M17.83 4.194l.42-1.377a1 1 0 1 1 1.913.585l-1.17 3.825a1 1 0 0 1-1.248.664l-3.825-1.17a1 1 0 1 1 .585-1.912l1.672.511A7.381 7.381 0 0 0 3.185 6.584l-.26.633a1 1 0 1 1-1.85-.758l.26-.633A9.381 9.381 0 0 1 17.83 4.194zM2.308 14.807l-.327 1.311a1 1 0 1 1-1.94-.484l.967-3.88a1 1 0 0 1 1.265-.716l3.828.954a1 1 0 0 1-.484 1.941l-1.786-.445a7.384 7.384 0 0 0 13.216-1.792 1 1 0 1 1 1.906.608 9.381 9.381 0 0 1-5.38 5.831 9.386 9.386 0 0 1-11.265-3.328z' /></svg>
                    </span>
                    <span class="mx2">Opdater</span>
                  </button>
                </div>
              </form>
            </div>
          </b-tab>
          <b-tab>
            <template #title>
              <img src='static/svg/protection.svg' width='28' height='28'><p class='inline-block h6 p1 gibson'>Tilladelser</p>
            </template>
            <div class="px1 py3">
              <form @submit="onUpdateDomain">
                <div class="clearfix">
                  <b-form-group id="settings1" class="font-weight-bold text-dark">
                    <label label-for="domain" class="h5 semi-bold darkblue gibson mb1">
                      Domænenavn
                    </label>
                    <b-form-input id="siteTitle" v-model="domainSettings.domain" required :disabled="showDomain" class="border-none not-rounded gibson p2 h5 muted-background darkblue"></b-form-input>
                  </b-form-group>
                </div>
                <div class="clearfix">
                  <b-form-group class="font-weight-bold text-dark">
                    <label class="h5 semi-bold darkblue gibson mb1">
                      Select
                    </label>
                    <b-form-checkbox-group plain v-model="domainSettings.services" :disabled="showDomain" :options="options" />
                  </b-form-group>
                </div>
                <div class="clearfix">
                  <b-form-group id="settings1">
                    <label label-for="dkuser" class="h5 semi-bold darkblue gibson mb1">
                      DKhostmaster Bruger-id
                    </label>
                    <b-form-input id="siteTitle" v-model="domainSettings.dkuser" :disabled="showDomain" required class="border-none not-rounded gibson p2 h5 muted-background darkblue"></b-form-input>
                    <span class="h5 mediumgrey regular line-height-3 gibson">
                      Input beskrivelse
                    </span>
                  </b-form-group>
                </div>
                <div class="clearfix">
                  <b-form-group id="settings1">
                    <label label-for="dkpassword" class="h5 semi-bold darkblue gibson mb1">
                      DKhostmaster Adgangskode
                    </label>
                    <b-form-input id="siteTitle" v-model="domainSettings.dkpassword" :disabled="showDomain" required class="border-none not-rounded gibson p2 h5 muted-background darkblue"></b-form-input>
                  </b-form-group>
                </div>
                <div class="clearfix">
                  <b-form-group id="settings1">
                    <label label-for="email1" class="h5 semi-bold darkblue gibson mb1">
                      Email Address 1
                    </label>
                    <b-form-input id="siteTitle" v-model="domainSettings.email1" :disabled="showDomain" class="border-none not-rounded gibson p2 h5 muted-background darkblue"></b-form-input>
                  </b-form-group>
                </div>
                <div class="clearfix">
                  <b-form-group id="settings1">
                    <label label-for="email2" class="h5 semi-bold darkblue gibson mb1">
                      Email Address 2
                    </label>
                    <b-form-input id="siteTitle" v-model="domainSettings.email2" :disabled="showDomain" class="border-none not-rounded gibson p2 h5 muted-background darkblue"></b-form-input>
                  </b-form-group>
                </div>
                <div class="clearfix">
                  <button type="submit" class="col-12 not-rounded p2 gibson action-button h4 semi-bold flex justify-center items-center" v-if="!showDomain">
                    <span>Submit</span>
                    <span class="mx2">
                      <i class="el-icon-right"></i>
                    </span>
                  </button>
                  <b-alert :show="showDomain" class="h5 gibson line-height-golden white p2 green-background">Du har nu opdateret dine domæneinformationer. Vi vil derfor begynde opsætningen af dit domæne og email</b-alert>
                </div>
              </form>
            </div>
          </b-tab>
          <b-tab >
            <template #title>
              <img src='static/svg/settings.svg' width='28' height='28'><p class='inline-block h6 p1 gibson'>E-mail</p>
            </template>
            <webemailcontents :filteredPosts="filteredPostsEmail"   :emaildomain="emaildomain" :numemail="numemail" :numemailused="numemailused"  @Reload="Reload"></webemailcontents>
          </b-tab>
        </b-tabs>
      </div>
      <div v-if="!showMobile">
        <b-tabs pills>
          <b-tab>
            <template #title>
              <div class="flex justify-start items-center">
                <img class="mr1" src='static/svg/sitemap.svg' width='18' height='18'>
                <p class='inline-block h6 line-height-1 m0 p0 gibson'>Sider</p>
              </div>
            </template>
            <websitecontents :filteredPosts="filteredPosts" @Reload="Reload"></websitecontents>
          </b-tab>
          <b-tab>
            <template #title>
              <div class="flex justify-start items-center">
                <img class="mr1" src='static/svg/list.svg' width='18' height='18'>
                <p class='inline-block h6 line-height-1 m0 p0 gibson'>Sidernes rækkefølge</p>
              </div>
            </template>
            <websitesort :filteredPosts="filteredPosts" :titles="titles" :filteredSorts="filteredSorts" @Reload="Reload" ></websitesort>
          </b-tab>
          <b-tab>
            <template #title>
              <div class="flex justify-start items-center">
                <img class="mr1" src='static/svg/layout.svg' width='18' height='18'>
                <p class='inline-block h6 line-height-1 m0 p0 gibson'>Temaer</p>
              </div>
            </template>
            <div class="clearfix flex flex-wrap justify-start items-start">
              <div class="col col-5 mb4 p2 pb4 overflow-hidden" v-for="template in templates" :key="template.id">
                <div class="relative">
                  <div class="relative" style="height:320px;">
                    <img class="fit" :src="template.img" :alt="template.id">
                  </div>
                  <div class="absolute right-0 bottom-0 left-0">
                    <div class="col-6 mx-auto highlights flex flex-column p1 white-background">
                      <span class="block mb2 flex justify-between items-center">
                        <span class="h6 darkblue gibson line-height-1 m0 p0 capitalize" style="font-size:90%">
                          {{template.id}}
                        </span>
                        <template>
                          <span v-if="template.id === 'theme1'" class="darkblue gibson block flex justify-start items-center">
                            <span class="green"><i class="el-icon-success"></i></span>
                            <span class="h6 regular m0 p0" style="font-size:90%">Menu</span>
                          </span>
                          <span class="red gibson block flex justify-start items-center" v-else>
                            <span><i class="el-icon-remove"></i></span>
                            <span class="h6 regular gibson m0 p0 line-height-1" style="font-size:90%">Menu</span>
                          </span>
                        </template>
                      </span>
                      <button type="button" v-if="template.id !== vtemplate" @click="Updatetemplate(template.id)" class="action-button gibson line-height-1 flex justify-center items-center h6 regular py1 px2 flex-none mx-auto">
                        <span style="font-size:90%">Vælg</span>
                      </button>
                      <div class="center mx-auto py1 px2 border green-border mb1" v-if="template.id === vtemplate">
                        <p class="h6 gibson green line-height-1 m0 p0" style="font-size:90%">Valgte</p>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- <b-card :title="template.id" name="template" :img-src="template.img" :img-alt="template.id" img-top style="max-width: 20rem;"
                  class="mb-2 items-center">
                  <b-button v-if="template.id !== vtemplate" @click="Updatetemplate(template.id)"  variant="primary">Vælg</b-button>
                  <p class="h4 semi-bold green mt1" v-if="template.id === vtemplate">valgte</p>
                </b-card> -->
              </div>
            </div>
          </b-tab>
          <b-tab>
            <template #title>
              <div class="flex justify-start items-center">
                <img class="mr1" src='static/svg/settings.svg' width='18' height='18'>
                <p class='inline-block h6 line-height-1 m0 p0 gibson'>Indstillinger</p>
              </div>
            </template>
            <div class="xs-col-12 sm-col-12 md-col-6 lg-col-6 px1">
              <form @submit="onUpdateSettings" @reset="onResetSettings">
                <div class="py2"></div>
                <div class="clearfix mb3">
                  <b-form-group id="settings1" class="gibson h5 regular mb1 darkblue">
                    <label label-for="siteTitle" class="h5 semi-bold darkblue gibson mb1">Navn på hjemmeside</label>
                    <b-form-input id="siteTitle" v-model="siteSettings.Title" class="border-none not-rounded gibson p2 h5 muted-background darkblue"></b-form-input>
                    <span class="h5 mediumgrey regular line-height-3 gibson">
                      Her skriver du navnet på din hjemmeside fx hansensvvs.dk
                    </span>
                  </b-form-group>
                </div>
                <div class="clearfix mb3">
                  <b-form-group id="settings3">
                    <label label-for="siteKeywords" class="h5 semi-bold darkblue gibson mb1">Søgeord</label>
                    <b-form-input id="siteKeywords" v-model="siteSettings.Keywords" class="border-none not-rounded gibson p2 h5 muted-background darkblue"></b-form-input>
                    <span class="h5 mediumgrey regular line-height-3 gibson">
                      Her skriver du de søgeord, som du ønsker at din hjemmeside skal blive fundet på, det kan fx være dit firmanavn, produktnavne eller lignende
                    </span>
                  </b-form-group>
                </div>
                <div class="clearfix mb3">
                  <b-form-group id="settings1">
                    <label label-for="Facebook" class="h5 semi-bold darkblue gibson mb1">
                      Link til virksomhedens Facebookside
                    </label>
                    <b-form-input id="Facebook" v-model="siteSettings.facebook" class="border-none not-rounded gibson p2 h5 muted-background darkblue"></b-form-input>
                    <span class="h5 mediumgrey regular line-height-3 gibson">
                      Hvis du ønsker at tilføje et link til din virksomheds profil på de Facebook/Instagram kan du gøre det her
                    </span>
                  </b-form-group>
                </div>
                <div class="clearfix mb3">
                  <b-form-group id="settings3" label="" >
                    <label label-for="Instagram" class="h5 semi-bold darkblue gibson mb1">
                      Link til virksomhedens Instagramside
                    </label>
                    <b-form-input id="Twitter" v-model="siteSettings.twitter" class="border-none not-rounded gibson p2 h5 muted-background darkblue"></b-form-input>
                    <span class="h5 mediumgrey regular line-height-3 gibson">
                      Hvis du ønsker at tilføje et link til din virksomheds profil på de Facebook/Instagram kan du gøre det her
                    </span>
                  </b-form-group>
                </div>
                <div class="clearfix mb3">
                  <b-form-group id="settings2">
                    <label label-for="siteDescription" class="h5 semi-bold darkblue gibson mb1">Beskrivelse</label>
                    <b-form-textarea id="siteDescription" v-model="siteSettings.Description" :rows="8" :max-rows="6" class="border-none not-rounded gibson p2 h5 muted-background darkblue"></b-form-textarea>
                    <span class="h5 mediumgrey regular line-height-3 gibson">
                      Som standard vil beskrivelsen på din hjemmeside, være din profiltekst fra Håndværker.dk, ønsker du at lave en anden beskrivelse, kan du gøre det her
                    </span>
                  </b-form-group>
                </div>
                <div class="clearfix mb3">
                  <template>
                    <div v-if="!image">
                      <div class="font-weight-bold p-1">Logo</div>
                      <input type="file" @change="onFileChange">
                    </div>
                    <div v-else>
                      <p class="h5 semi-bold gibson mb2 darkblue">
                        Logo
                      </p>
                      <div class="flex justify-between items-center">
                        <img :src="image" />
                        <button class="not-rounded p1 delete-button" @click="removeImage">
                          <span>
                            <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-3 -2 24 24" width="24" height="24" preserveAspectRatio="xMinYMin" class="jam jam-trash"><path d='M6 2V1a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v1h4a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2h-.133l-.68 10.2a3 3 0 0 1-2.993 2.8H5.826a3 3 0 0 1-2.993-2.796L2.137 7H2a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h4zm10 2H2v1h14V4zM4.141 7l.687 10.068a1 1 0 0 0 .998.932h6.368a1 1 0 0 0 .998-.934L13.862 7h-9.72zM7 8a1 1 0 0 1 1 1v7a1 1 0 0 1-2 0V9a1 1 0 0 1 1-1zm4 0a1 1 0 0 1 1 1v7a1 1 0 0 1-2 0V9a1 1 0 0 1 1-1z'/></svg>
                          </span>
                        </button>
                      </div>
                    </div>
                  </template>
                </div>
                <div class="clearfix mb3">
                  <button type="submit" class="not-rounded action-button gibson h4 regular col-12 flex justify-center items-center p2">
                    <span>
                      <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="-1.5 -2.5 24 24" width="24" height="24" preserveAspectRatio="xMinYMin" class="jam jam-refresh"><path d='M17.83 4.194l.42-1.377a1 1 0 1 1 1.913.585l-1.17 3.825a1 1 0 0 1-1.248.664l-3.825-1.17a1 1 0 1 1 .585-1.912l1.672.511A7.381 7.381 0 0 0 3.185 6.584l-.26.633a1 1 0 1 1-1.85-.758l.26-.633A9.381 9.381 0 0 1 17.83 4.194zM2.308 14.807l-.327 1.311a1 1 0 1 1-1.94-.484l.967-3.88a1 1 0 0 1 1.265-.716l3.828.954a1 1 0 0 1-.484 1.941l-1.786-.445a7.384 7.384 0 0 0 13.216-1.792 1 1 0 1 1 1.906.608 9.381 9.381 0 0 1-5.38 5.831 9.386 9.386 0 0 1-11.265-3.328z' /></svg>
                    </span>
                    <span class="mx2">Opdater</span>
                  </button>
                </div>
              </form>
            </div>
          </b-tab>
          <b-tab>
            <template #title>
              <div class="flex justify-start items-center">
                <img class="mr1"src='static/svg/protection.svg' width='18' height='18'>
                <p class='inline-block h6 line-height-1 m0 p0 gibson'>Tilladelser</p>
              </div>
            </template>
            <div class="xs-col-12 sm-col-12 md-col-6 lg-col-6 px1 py3">
              <form @submit="onUpdateDomain">
                <div class="clearfix">
                  <b-form-group id="settings1" class="font-weight-bold text-dark">
                    <label label-for="domain" class="h5 semi-bold darkblue gibson mb1">
                      Domænenavn
                    </label>
                    <b-form-input id="siteTitle" v-model="domainSettings.domain" required :disabled="showDomain" class="border-none not-rounded gibson p2 h5 muted-background darkblue"></b-form-input>
                  </b-form-group>
                </div>
                <div class="clearfix">
                  <b-form-group class="font-weight-bold text-dark">
                    <label class="h5 semi-bold darkblue gibson mb1">
                      Select
                    </label>
                    <b-form-checkbox-group plain v-model="domainSettings.services" :disabled="showDomain" :options="options" />
                  </b-form-group>
                </div>
                <div class="clearfix">
                  <b-form-group id="settings1">
                    <label label-for="dkuser" class="h5 semi-bold darkblue gibson mb1">
                      DKhostmaster Bruger-id
                    </label>
                    <b-form-input id="siteTitle" v-model="domainSettings.dkuser" :disabled="showDomain" required class="border-none not-rounded gibson p2 h5 muted-background darkblue"></b-form-input>
                    <span class="h5 mediumgrey regular line-height-3 gibson">
                      Input beskrivelse
                    </span>
                  </b-form-group>
                </div>
                <div class="clearfix">
                  <b-form-group id="settings1">
                    <label label-for="dkpassword" class="h5 semi-bold darkblue gibson mb1">
                      DKhostmaster Adgangskode
                    </label>
                    <b-form-input id="siteTitle" v-model="domainSettings.dkpassword" :disabled="showDomain" required class="border-none not-rounded gibson p2 h5 muted-background darkblue"></b-form-input>
                  </b-form-group>
                </div>
                <div class="clearfix">
                  <b-form-group id="settings1">
                    <label label-for="email1" class="h5 semi-bold darkblue gibson mb1">
                      Email Address 1
                    </label>
                    <b-form-input id="siteTitle" v-model="domainSettings.email1" :disabled="showDomain" class="border-none not-rounded gibson p2 h5 muted-background darkblue"></b-form-input>
                  </b-form-group>
                </div>
                <div class="clearfix">
                  <b-form-group id="settings1">
                    <label label-for="email2" class="h5 semi-bold darkblue gibson mb1">
                      Email Address 2
                    </label>
                    <b-form-input id="siteTitle" v-model="domainSettings.email2" :disabled="showDomain" class="border-none not-rounded gibson p2 h5 muted-background darkblue"></b-form-input>
                  </b-form-group>
                </div>
                <div class="clearfix">
                  <button type="submit" class="col-12 not-rounded p2 gibson action-button h4 semi-bold flex justify-center items-center" v-if="!showDomain">
                    <span>Submit</span>
                    <span class="mx2">
                      <i class="el-icon-right"></i>
                    </span>
                  </button>
                  <b-alert :show="showDomain" class="h5 gibson line-height-golden white p2 green-background">Du har nu opdateret dine domæneinformationer. Vi vil derfor begynde opsætningen af dit domæne og email</b-alert>
                </div>
              </form>
            </div>
          </b-tab>
          <b-tab>
            <template #title>
              <div class="flex justify-start items-center">
                <img class="mr1" src='static/svg/email.svg' width='18' height='18'>
                <p class='inline-block h6 line-height-1 m0 p0 gibson'>E-mail</p>
              </div>
            </template>
            <webemailcontents :filteredPosts="filteredPostsEmail"   :emaildomain="emaildomain" :numemail="numemail" :numemailused="numemailused"  @Reload="Reload"></webemailcontents>
          </b-tab>
        </b-tabs>
      </div>
    </template>
    <loading :show="show" :label="label" :overlay="overlay"></loading>
    <simplert :useRadius="true" :useIcon="true" ref="simplert"></simplert>
  </main>
</template>
<script>
import loading from 'vue-full-loading'
import Simplert from 'vue2-simplert'
import websitecontents from './websitecontents'
import webemailcontents from './webemailcontents'
import websitesort from './websitesort'
import { BTab, BTabs } from 'bootstrap-vue'
export default {
  name: 'websitecontrols',
  components: {
    loading,
    websitecontents,
    webemailcontents,
    websitesort,
    Simplert,
    'b-tab': BTab,
    'b-tabs': BTabs
  },
  data () {
    return {
      showMobile: false,
      siteSettings: {
        Title: '',
        Description: '',
        Keywords: '',
        facebook: '',
        twitter: ''
      },
      domainSettings: {
        domain: '',
        services: [],
        dkuser: '',
        dkpassword: '',
        email1: '',
        email2: ''
      },
      showDomain: false,
      filteredPosts: [],
      filteredPostsEmail: [],
      filteredSorts: [],
      titles: [],
      vtemplate: 'theme1',
      templates: [],
      image: '',
      emaildomain: '',
      numemail: '',
      numemailused: '',
      show: false,
      label: 'Loading...',
      picked: '',
      overlay: true,
      selected: [],
      options: [
        {text: 'DNS', value: 'DNS'},
        {text: 'Mailadresse', value: 'Mailadresse'}
      ]
    }
  },
  created () {
    if (screen.width <= 640) {
      this.showMobile = true
    } else {
      this.showMobile = false
    }
    this.Reload()
  },
  methods: {
    onUpdateSettings (evt) {
      evt.preventDefault()
      this.show = true
      this.salesPerson = localStorage.getItem('id_token_portal')
      this.haaId = localStorage.getItem('haaid')
      var data = { operation: 'saveWebsiteSetting', salesPerson: this.salesPerson, levid: this.haaId, siteSettings: JSON.stringify(this.siteSettings), image: this.image }
      this.$http.post('', data, { emulateJSON: true })
        .then(
          response => {
            this.show = false
            var res = response.body
            if (res.success) {
              let closeFn = function () {
              }
              let obj = {
                title: 'Gennemført!',
                message: '',
                type: 'success',
                onClose: closeFn,
                customCloseBtnText: 'Luk'
              }
              this.$refs.simplert.openSimplert(obj)
            } else {
              let obj = {
                title: 'Fejl',
                message: 'Fejl - Kontakt venligst administrator',
                type: 'error',
                customCloseBtnText: 'Luk'
              }
              this.$refs.simplert.openSimplert(obj)
            }
          },
          response => {
            alert('error')
          }
        )
    },
    Updatetemplate (templateId) {
      this.show = true
      this.salesPerson = localStorage.getItem('id_token_portal')
      this.haaId = localStorage.getItem('haaid')
      var data = { operation: 'Updatetemplate', salesPerson: this.salesPerson, levid: this.haaId, templateId: templateId }
      this.$http.post('', data, { emulateJSON: true })
        .then(
          response => {
            this.show = false
            var res = response.body
            if (res.success) {
              let closeFn = function () {
              }
              let obj = {
                title: 'Gennemført!',
                message: '',
                type: 'success',
                onClose: closeFn,
                customCloseBtnText: 'Luk'
              }
              this.vtemplate = templateId
              this.$refs.simplert.openSimplert(obj)
            } else {
              let obj = {
                title: 'Fejl',
                message: 'Fejl - Kontakt venligst administrator',
                type: 'error',
                customCloseBtnText: 'Luk'
              }
              this.$refs.simplert.openSimplert(obj)
            }
          },
          response => {
            alert('error')
          }
        )
    },
    onUpdateDomain (evt) {
      evt.preventDefault()
      this.show = true
      this.salesPerson = localStorage.getItem('id_token_portal')
      this.haaId = localStorage.getItem('haaid')
      var data = { operation: 'saveWebsiteDomain', salesPerson: this.salesPerson, levid: this.haaId, domainSettings: JSON.stringify(this.domainSettings) }
      this.$http.post('', data, { emulateJSON: true })
        .then(
          response => {
            this.show = false
            var res = response.body
            if (res.success) {
              let closeFn = function () {
              }
              let obj = {
                title: 'Gennemført!',
                message: '',
                type: 'success',
                onClose: closeFn,
                customCloseBtnText: 'Luk'
              }
              this.showDomain = true
              this.$refs.simplert.openSimplert(obj)
            } else {
              let obj = {
                title: 'Fejl',
                message: 'Fejl - Kontakt venligst administrator',
                type: 'error',
                customCloseBtnText: 'Luk'
              }
              this.$refs.simplert.openSimplert(obj)
            }
          },
          response => {
            alert('error')
          }
        )
    },
    Reload () {
      this.salesPerson = localStorage.getItem('id_token_portal')
      this.haaId = localStorage.getItem('haaid')
      var data = {operation: 'WebsiteSetting', salesPerson: this.salesPerson, levid: this.haaId}
      this.$http.post('', data, { emulateJSON: true })
        .then(
          response => {
            var res = response.body
            if (res.login === false) {
              this.$router.push('/login')
            }
            if (res.settings) {
              this.siteSettings = res.settings
            }
            if (res.domain) {
              this.domainSettings = res.domain
              this.showDomain = true
            }
            this.filteredPosts = res.pages
            this.filteredPostsEmail = res.emails
            this.emaildomain = res.emaildomain
            this.numemail = res.numemail
            this.numemailused = res.numemailused
            this.filteredSorts = res.sort
            this.titles = res.title
            this.image = res.image
            this.templates = res.templates
            this.vtemplate = res.vtemplate
            this.$emit('UpdateUrl', res.url)
          },
          response => {
            alert('error')
          }
        )
    },
    onFileChange (e) {
      var files = e.target.files || e.dataTransfer.files
      if (!files.length) {
        return
      }
      this.createImage(files[0])
    },
    createImage (file) {
      var reader = new FileReader()
      var vm = this
      reader.onload = (e) => {
        vm.image = e.target.result
      }
      reader.readAsDataURL(file)
    },
    removeImage: function (e) {
      this.image = ''
    },
    onResetSettings (evt) {
      evt.preventDefault()
      /* Reset our form values */
      // this.siteSettings.siteTitle = ''
      // this.siteSettings.siteDescription = ''
      // this.siteSettings.siteKeywords = ''
      // this.form.food = null;
      // this.form.checked = [];
      //  Trick to reset/clear native browser form validation state
      this.show = false
      // this.$nextTick(() => { this.show = true });
    }
  }
}
</script>
<style>
/* .tab-content {
  border:0;
} */
.col-form-label {
  font-weight: 600;
}
.card-header {
  background: none;
}
.col-auto {
  width: 100%!important;
  min-height: 32px;
}
.nav-pills .nav-link.active {
  background: rgba(178,190,195, 0.175);
  font-weight: 700;
}
.form-check-input {
  margin-left: 0rem;
}
</style>



// WEBPACK FOOTER //
// WebsiteControls.vue?1b1ca81e